var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
import { action, runInAction } from 'mobx';
import { HotseatBackend } from '../hotseat/HotseatBackend.js';
import { AbstractGameSuite } from './AbstractGameSuite.js';
import { ROOT_CHAT_SCENE_ID } from './GameSessionSuite.js';
let HotseatGameSuite = (() => {
    let _classSuper = AbstractGameSuite;
    let _switchPlayer_decorators;
    let _switchPlayer_initializers = [];
    let _switchPlayer_extraInitializers = [];
    return class HotseatGameSuite extends _classSuper {
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _switchPlayer_decorators = [action];
            __esDecorate(null, null, _switchPlayer_decorators, { kind: "field", name: "switchPlayer", static: false, private: false, access: { has: obj => "switchPlayer" in obj, get: obj => obj.switchPlayer, set: (obj, value) => { obj.switchPlayer = value; } }, metadata: _metadata }, _switchPlayer_initializers, _switchPlayer_extraInitializers);
            if (_metadata) Object.defineProperty(this, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        }
        ctx;
        static load = async (gameSessionId, gameModules) => {
            const backend = await HotseatBackend.open(gameSessionId, gameModules);
            const details = await backend.getDetails();
            const chat = await backend.getChats();
            return new HotseatGameSuite({
                ...details,
                youAreLeader: true,
                playerId: details.members[0].id, // Just start with the first player
                chat,
            }, { gameModules, backend });
        };
        isHotseat = true;
        constructor(init, ctx) {
            super(init, { gameModules: ctx.gameModules });
            this.ctx = ctx;
            runInAction(() => {
                this.playerId =
                    localStorage.getItem(`hotseat-last-player:${init.id}`) || init.playerId;
                this.pickingPlayer = true; // show player picker on launch
                // hotseat backend doesn't fire an initial chat event like the
                // real one does, so we load it up here.
                this.sceneChats[ROOT_CHAT_SCENE_ID] = {
                    messages: init.chat,
                    empty: false,
                    nextToken: null,
                };
            });
            this.ctx.backend.subscribe('chat', this.onChat);
            this.ctx.backend.subscribe('gameChange', this.onGameChange);
            this.ctx.backend.subscribe('roundChange', this.onRoundChange);
            this.ctx.backend.subscribe('turnPlayed', this.onTurnPlayed);
            this.ctx.backend.subscribe('playerStatusChange', this.onPlayerStatusChange);
            this.ctx.backend.subscribe('statusChange', this.onStatusChange);
            this.ctx.backend.subscribe('membersChange', this.onMembersChange);
            this.ctx.backend.subscribe('gameStarting', this.onGameStarting);
        }
        get backend() {
            return this.ctx.backend;
        }
        connect() {
            // no-op
            return this.disconnect;
        }
        disconnect() {
            // no-op
        }
        loadRound = (roundIndex) => {
            return this.ctx.backend.getRound(this.playerId, roundIndex);
        };
        actuallySubmitTurn = async (data, playerId) => {
            console.log(`Submitting turn for round ${this.latestRoundIndex}`, data);
            const error = await this.ctx.backend.submitTurn({
                data,
                playerId,
                roundIndex: this.latestRoundIndex,
                createdAt: new Date().toISOString(),
            });
            if (error) {
                return error;
            }
            // turn was submitted, back to picking player.
            runInAction(() => {
                this.pickingPlayer = true;
            });
        };
        actuallySendChat = async (message) => {
            await this.ctx.backend.addChat(message);
        };
        actuallyLoadMoreChat = async (nextToken, sceneId) => {
            const chats = await this.ctx.backend.getChats(sceneId);
            this.onChat({
                type: 'chat',
                messages: chats,
                sceneId: sceneId ?? null,
                nextToken: null, // Hotseat doesn't use pagination
            });
        };
        toggleChatReaction = async (chatMessage, reaction) => {
            // not implemented
            console.error('Chat reactions are not implemented in hotseat mode');
        };
        startGame = async () => {
            await this.ctx.backend.startGame();
        };
        voteForGame = (gameId) => {
            this.ctx.backend.setGame(gameId);
        };
        removeVoteForGame = (gameId) => {
            throw new Error('Method not implemented.');
        };
        getPostgame = async () => {
            const { globalState } = await this.ctx.backend.getGlobalState(this.latestRoundIndex);
            return globalState;
        };
        async getGameData() {
            const data = await this.ctx.backend.getDetails();
            console.log('game details', data);
            return {
                ...data,
                youAreLeader: true,
                playerId: this.playerId,
            };
        }
        getMembers = () => {
            return this.ctx.backend.getMembers();
        };
        resetGame = async () => {
            await this.ctx.backend.resetGame();
        };
        switchPlayer = __runInitializers(this, _switchPlayer_initializers, (playerId) => {
            this.playerId = playerId;
            this.pickingPlayer = false;
            localStorage.setItem(`hotseat-last-player:${this.gameSessionId}`, playerId);
            this.events.emit('playerChanged', playerId);
            console.log(`Switched to player ${playerId}`);
        });
        getDevModeTurns() {
            return this.ctx.backend.getTurns(this.latestRoundIndex);
        }
        // not part of public interface, but usable in console
        setSeed = (__runInitializers(this, _switchPlayer_extraInitializers), (seed) => {
            this.ctx.backend.setSeed(seed);
        });
    };
})();
export { HotseatGameSuite };
//# sourceMappingURL=HotseatGameSuite.js.map